import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-cerrix-select",
    imports: [MatIcon],
    templateUrl: "./cerrix-select.component.html",
    styleUrl: "./cerrix-select.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixSelectComponent implements AfterViewInit {
    @Input() options: { label: string; value: string }[] = [];
    @Input() placeholder: string = "";
    @Input() selectedValue: string | null | undefined = null;
    @Input() disabled: boolean = false;

    @Output() selectionChange = new EventEmitter<string>();

    @ViewChild("select") selectElement: ElementRef<HTMLSelectElement>;

    ngAfterViewInit(): void {
        const selectedIndex = this.getSelectedIndex();
        if (selectedIndex >= 0 && selectedIndex < this.options.length) {
            const selectedOption = this.options[selectedIndex];
            this.selectElement.nativeElement.value = selectedOption.value;
            if (!this.disabled && !this.selectedValue && selectedOption.value) {
                this.selectionChange.emit(selectedOption.value);
            }
        }
    }
    private getSelectedIndex(): number {
        if (!this.selectedValue) return 0;
        const idx = this.options.findIndex((o) => o.value === this.selectedValue);
        return idx >= 0 ? idx : 0;
    }

    public changeSelection(value: string): void {
        this.placeholder = "";
        this.selectionChange.emit(value);
    }

    public hasPlaceholder(): boolean {
        return this.placeholder && this.placeholder.trim().length > 0;
    }
}
